<template>
  <div>
    <h1>Blank</h1>
    <p>This is a blank template. Nobody should ever see this. If you do, please alert Dan.</p>

  </div>
</template>

<script>
  export default {
    data () {
      return {
        foo: 'bar'
      }
    },
    mounted () {
      console.log('Blank component mounted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Terms/SubmissionTerms.vue